import { cn } from '@/lib/utils';

export const ASSIGN_ROW_HINT = 'Hold or tap to assign';
export const ASSIGN_ROW_SELECTED_LABEL = 'Selected';
export const ASSIGN_ROW_DRAG_HINT = 'Drag →';

export type AssignRowStateClassNameOptions = {
  isDragging?: boolean;
  isSelected?: boolean;
  tapAssignEnabled?: boolean;
  draggingClassName?: string;
};

export function getAssignRowStateClassName({
  isDragging = false,
  isSelected = false,
  tapAssignEnabled = false,
  draggingClassName = 'opacity-50 ring-2 ring-blue-300',
}: AssignRowStateClassNameOptions) {
  return cn(
    isDragging && draggingClassName,
    isSelected && 'ring-2 ring-indigo-400 bg-indigo-50/40',
    tapAssignEnabled && 'cursor-grab touch-manipulation select-none active:cursor-grabbing',
  );
}

export function getAssignRowHint(isSelected: boolean) {
  return isSelected ? ASSIGN_ROW_SELECTED_LABEL : ASSIGN_ROW_HINT;
}
